export interface IBaccaratWinType {
	player: string;
	banker: string;
	playerValue: number;
	bankerValue: number;
}

/**
 * Check Baccarat tie.
 */
const checkPlayerBankerTie = (win: any, val: number) =>
	win &&
	(win.playerValue === win.bankerValue) &&
	(parseInt(win.playerValue, 10) === val);

export {
	checkPlayerBankerTie
}